<template>
  <div class="new-password">
    <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="58">
      <FormItem label="原始密码" prop="oldPasswd" :error="formObjError.oldPasswd" :key="key">
        <Input type="password" v-model.trim="formCustom.oldPasswd" :maxlength="15" placeholder="请输入原始密码" autocomplete="off"></Input>
      </FormItem>
      <FormItem label="新密码" prop="newPasswd">
        <Input type="password" v-model.trim="formCustom.newPasswd" placeholder="请输入新密码" autocomplete="off" :maxlength="20"></Input>
        <p class="hint">6-20位字符，可由英文及数字组成</p>
      </FormItem>
      <FormItem label="确认密码" prop="passwdCheck">
        <Input type="password" v-model.trim="formCustom.passwdCheck"  autocomplete="off" :maxlength="20" placeholder="请再次确认密码"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit()">确认提交</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import { getEditPassword } from '@/api/app'
export default {
  name: 'new-password',
  created() {
    this.$store.dispatch('setPage', { title: '修改密码', type: 'default' })
  },
  data() {
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入原密码'))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else if (value.length < 6) {
        callback(new Error('密码最短为6位，最长为20位'))
      } else {
        callback()
      }
    }
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('确认密码不能为空'))
      } else if (value !== this.formCustom.newPasswd && value !== '') {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      formCustom: {
        oldPasswd: '',
        newPasswd: '',
        passwdCheck: ''
      },
      formObjError: {
        oldPasswd: ''
      },
      ruleCustom: {
        oldPasswd: [
          { validator: validateName, trigger: 'blur' }
        ],
        newPasswd: [
          { validator: validatePass, trigger: 'blur' }
        ],
        passwdCheck: [
          { validator: validatePassCheck, trigger: 'blur' }
        ]
      },
      key: 1
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.formCustom.validate((valid) => {
        if (valid) {
          getEditPassword({
            admin_password_old: this.formCustom.oldPasswd,
            admin_password: this.formCustom.newPasswd,
            admin_rpassword: this.formCustom.passwdCheck
          }).then(res => {
            if (res.code === 0) {
              this.$Message.success('密码修改成功')
              this.$router.go(-1)
            } else {
              this.key = Math.random()
              this.formObjError.oldPasswd = res.msg
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
  .new-password {
    padding: 10px 0 10px 222px;
    .hint {
      height:12px;
      font-size:12px;
      font-weight:400;
      color:rgba(181,194,208,1);
      line-height:12px;
      margin-top: 10px;
    }
    .ivu-form .ivu-form-item-label {
      padding: 0 0;
      font {
        display: inline-block;
        height: 32px;
        line-height: 32px;
        vertical-align: initial!important;
      }
      &:before {
         content: "*";
         display: inline-block;
         line-height: 1;
         font-size: 12px;
         color: #ed4014;
       }
    }
    .ivu-input {
      width: 210px;
      height: 32px;
      line-height: 32px;
      background:rgba(255,255,255,1);
      font-size: 12px;
      border-radius:4px;
      padding: 10px 10px;
      border:1px solid rgba(210,220,230,1);
      &:focus{
         border:1px solid rgba(24,129,220,1);
         outline:none!important;
         box-shadow: none;
       }
    }
    .ivu-form-item-error{
      .ivu-input {
        font-size: 12px;
        border:1px solid rgba(210,220,230,1);
      &:focus{
         border:1px solid rgba(24,129,220,1);
         outline:none!important;
         box-shadow: none;
       }
      }
    }
    .ivu-select {
      font-size: 12px;
      width: 210px;
      height: 32px;
      line-height: 32px;
    }
    .ivu-select-single .ivu-select-selection {
      height: 32px;
      line-height: 32px;
    }
    .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
      height: 32px;
      line-height: 32px;
    }
    .ivu-form-item {
      margin-bottom: 20px;
    }
  .ivu-form-item:last-child {
    margin-bottom: 0;
    height: 28px;
    line-height: 28px;
    min-height: 28px;
    margin-top: 30px;
  }
    .ivu-form-item-error-tip {
      top: 14px;
      padding: 0 0;
      position: absolute;
      left: 230px;
      font-size:12px;
      font-weight:400;
      color:rgba(220,24,24,1);
      line-height:12px;
    }
    .ivu-form-item-content {
      line-height: normal;
      font-size: 12px;
      padding-left: 10px;
    }
    .ivu-btn>span {
      vertical-align: bottom;
    }
  }
</style>
